import mod from "-!./editor.js?vue&type=script&lang=js&"; export default mod; export * from "-!./editor.js?vue&type=script&lang=js&"